/* eslint-disable no-debugger */
/* eslint-disable no-else-return */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import {
  DownloadOutlined,
  RotateLeftOutlined,
  RotateRightOutlined,
  SwapOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
} from "@ant-design/icons";
import { Image, Skeleton, Space, Tooltip } from "antd";
import React, { useMemo, useState } from "react";
import { heicToJpg } from "../../../../utils";
import { mediaDownloader } from "../../../../utils/mediaDownloader";
import KlipyWatermark from "../../../../icons/svg/klipy-watermark.svg";
import AudioPlayer from "../../../smai-calling/audioPlayer/audioComp";
import MediaPreview from "../../../commonComponents/MediaPreview";
import MediaPreviewTrigger from "../../../commonComponents/MediaPreviewTrigger";
import { buildMessageMediaItems } from "./mediaPreviewItems";
import "./image.css";
import { PDFRender } from "./multipleMediaView";

const MediaSharing = props => {
  const { selectedMedia, altText, className = "", direction } = props;
  // Shared previewer visibility. Audio has no previewer (it plays inline).
  const [previewOpen, setPreviewOpen] = useState(false);

  // Single item, so the previewer gets a one-slide list. Memoized — the
  // conversation re-renders on every socket message and this runs per bubble.
  const previewItems = useMemo(() => buildMessageMediaItems([selectedMedia]), [selectedMedia]);

  // Downloads keep going through mediaDownloader (proxied blob fetch + filename)
  // rather than the previewer's plain anchor. It takes the URL only — the
  // extension is derived from it — and resolves when the file has been fetched,
  // which is what drives the previewer's spinner.
  const handlePreviewDownload = item => mediaDownloader(item?.downloadUrl || item?.url);

  const handleMediaUI = mediaInfo => {
    if (mediaInfo?.mediaType?.includes("image")) {
      // KLIPY-sourced GIFs require a watermark on the shared content
      // (https://docs.klipy.com/attribution). Klipy assets are served from
      // static.klipy.com, so match on the host.
      const isKlipyGif = (selectedMedia?.mediaUrl || "").includes("klipy");
      return (
        <div className="relative">
          {/* preview={false} — antd's own lightbox (and its hover mask) is
              replaced by the shared MediaPreview + MediaPreviewTrigger. */}
          <MediaPreviewTrigger onPreview={() => setPreviewOpen(true)}>
            <Image
              className={`${className} cursor-pointer w-full h-auto max-h-[300px] object-cover rounded `}
              src={heicToJpg(selectedMedia.compressedMediaUrl || selectedMedia.mediaUrl)}
              preview={false}
              alt={altText}
              loading="lazy"
              placeholder={<Skeleton.Image active className="w-full h-[200px]" />}
            />
          </MediaPreviewTrigger>
          {isKlipyGif && (
            <img
              src={KlipyWatermark}
              alt="KLIPY"
              className="absolute bottom-1 right-1 h-[16px] pointer-events-none z-10"
            />
          )}
        </div>
      );
      // eslint-disable-next-line no-else-return
    } else if (mediaInfo?.mediaType?.includes("video")) {
      const mediaUrl = mediaInfo?.mediaUrl || "";
      return (
        // clickThrough + a bottom offset keep the native control bar usable, so
        // the video still plays inline; the mask above it opens the previewer.
        <MediaPreviewTrigger
          onPreview={() => setPreviewOpen(true)}
          clickThrough
          maskClassName="inset-x-0 top-0 bottom-12"
        >
          <video
            className="cursor-pointer w-full h-auto max-h-[300px] max-w-full rounded"
            controls
            poster={selectedMedia.compressedThumbnail || selectedMedia?.thumbnailUrl || ""}
          >
            <source src={mediaUrl} type="video/mp4" />
          </video>
        </MediaPreviewTrigger>
      );
    } else if (mediaInfo?.mediaType?.includes("audio")) {
      return <AudioPlayer audioLink={mediaInfo?.mediaUrl} direction={direction} />;
    } else {
      // Docs keep the filename + size row; its click now opens the shared
      // previewer instead of the separate PDF modal.
      return <PDFRender item={mediaInfo} index="pdf" onView={() => setPreviewOpen(true)} />;
    }
  };

  const isAudio = selectedMedia?.mediaType?.includes("audio");

  return selectedMedia ? (
    <div
      className={`flex items-end ${
        direction === "TO_LEAD" ? "justify-end" : "justify-start"
      } p-0 w-full max-w-[300px] overflow-hidden`}
    >
      {handleMediaUI(selectedMedia)}
      {/* Shared previewer — replaces antd's PreviewGroup, the MediaViewer video
          modal and the PDF popup. Mounted only while open. */}
      {previewOpen && !isAudio && (
        <MediaPreview
          open
          items={previewItems}
          onDownload={handlePreviewDownload}
          onClose={() => setPreviewOpen(false)}
        />
      )}
    </div>
  ) : null;
};

export default MediaSharing;

export const CustomImageToolbar = ({ selectedMedia, scale, actions }) => (
  <Space size={12} className="toolbar-wrapper">
    <Tooltip title="Download Image">
      <DownloadOutlined
        onClick={() =>
          mediaDownloader(selectedMedia?.mediaUrl, selectedMedia?.mediaType?.split("/")[1])
        }
      />
    </Tooltip>
    <SwapOutlined rotate={90} onClick={actions.onFlipY} />
    <SwapOutlined onClick={actions.onFlipX} />
    <RotateLeftOutlined onClick={actions.onRotateLeft} />
    <RotateRightOutlined onClick={actions.onRotateRight} />
    <ZoomOutOutlined disabled={scale === 1} onClick={actions.onZoomOut} />
    <ZoomInOutlined disabled={scale === 50} onClick={actions.onZoomIn} />
  </Space>
);
